var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 512,
    viewBox: "0 0 360 512",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 0C80.748 0 0 80.748 0 180C0 213.534 9.289 246.26 26.869 274.652L169.754 504.909C172.491 509.32 177.313 512 182.499 512C182.539 512 182.578 512 182.618 512C187.849 511.959 192.681 509.196 195.368 504.708L334.611 272.22C351.221 244.428 360 212.539 360 180C360 80.748 279.252 0 180 0ZM308.866 256.818L182.272 468.186L52.367 258.846C37.734 235.214 29.8 207.95 29.8 180C29.8 97.29 97.29 29.8 180 29.8C262.71 29.8 330.1 97.29 330.1 180C330.1 207.121 322.689 233.688 308.866 256.818Z",
    fill: "#B18F6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 90C130.374 90 90 130.374 90 180C90 229.309 129.717 270 180 270C230.903 270 270 228.767 270 180C270 130.374 229.626 90 180 90ZM180 240.2C146.743 240.2 119.8 213.167 119.8 180C119.8 146.916 146.916 119.8 180 119.8C213.084 119.8 240.1 146.916 240.1 180C240.1 212.683 213.784 240.2 180 240.2Z",
    fill: "#B18F6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.188f85c5204741bc8a387eff0db05bf7.svg";
export { ForwardRef as ReactComponent };